import { Controller } from "@hotwired/stimulus"

// The task kind form: shows the chosen layout's wording fields and keeps its
// preview in step with them. The other layouts' fields are disabled, so only
// the chosen layout's wording is sent.
export default class extends Controller {
  static targets = ["panel", "layoutHint", "layoutSelect"]

  connect() {
    this.panelTargets.forEach((panel) => this.refreshPanel(panel))
  }

  switchLayout() {
    const key = this.layoutSelectTarget.value
    this.panelTargets.forEach((panel) => {
      const active = panel.dataset.layout === key
      panel.hidden = !active
      panel.querySelectorAll("input, textarea, select").forEach((field) => { field.disabled = !active })
    })
    this.layoutHintTargets.forEach((hint) => { hint.hidden = hint.dataset.layout !== key })
  }

  refresh(event) {
    this.refreshPanel(event.target.closest("[data-task-kind-form-target~='panel']"))
  }

  refreshPanel(panel) {
    if (!panel) return
    const previews = (key) => panel.querySelectorAll(`[data-preview-for="${key}"]`)
    panel.querySelectorAll("[data-preview-key]").forEach((field) => {
      const value = field.value.trim()
      const text = value || field.placeholder
      previews(field.dataset.previewKey).forEach((el) => {
        el.textContent = text
        if (field.dataset.previewHideEmpty) el.hidden = !value
      })
    })
    const fields = panel.querySelector("[data-preview-fields]")
    const fieldList = panel.querySelector("[data-preview-field-list]")
    if (fields && fieldList) {
      const labels = fields.value.split("\n").map((line) => line.trim()).filter(Boolean)
      fieldList.replaceChildren(...labels.map((label) => {
        const row = document.createElement("span")
        row.className = "kind-preview__field"
        row.textContent = label
        return row
      }))
    }
    panel.querySelectorAll("[data-preview-toggle]").forEach((box) => {
      previews(box.dataset.previewToggle).forEach((el) => { el.hidden = !box.checked })
    })
    const items = panel.querySelector("[data-preview-items]")
    const list = panel.querySelector("[data-preview-list]")
    if (!items || !list) return
    const lines = items.value.split("\n").map((line) => line.trim()).filter(Boolean)
    list.replaceChildren(...(lines.length ? lines : [list.dataset.empty]).map((line) => {
      const row = document.createElement("li")
      row.textContent = line.replace(/\s*\(optional\)$/i, "")
      if (/\(optional\)$/i.test(line)) row.dataset.optional = "true"
      if (!lines.length) row.dataset.placeholder = "true"
      return row
    }))
  }
}
